import { css } from '@/styled-system/css';

export const accordionHeaderContentStyles = css.raw({
  'alignItems': 'center',
  'display': 'flex',
  'flex': 1,
  'gap': 'default',
  'minWidth': 0,
  'pointerEvents': 'none',
  'position': 'relative',
  'zIndex': 1,

  '& :where(a, button, input, select, textarea, summary, [contenteditable="true"], [role="button"], [role="checkbox"], [role="combobox"], [role="link"], [role="radio"], [role="switch"], [tabindex]:not([tabindex="-1"]))':
    {
      pointerEvents: 'all',
    },

  '& .c11n_accordion__header-content': {
    alignItems: 'center',
    display: 'flex',
    flex: 1,
    gap: 'default',
    justifyContent: 'space-between',
    minWidth: 0,
  },
});
